<template>
  <v-card>
    <v-card-title class="headline py-2">
      Настройки видимости колонок
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="closeForm">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-data-table :headers="headers" :items="objects" hide-actions no-data-text="Объекты отсутствуют">
        <template slot="items" slot-scope="props">
          <td>{{props.item.name+' ('+props.item.propsname+')'}}</td>
          <td class="text-xs-center">
            <v-tooltip top>
              <v-btn slot="activator" :class="props.item.status?'pa-0 green--text':'pa-0 red--text'" icon small flat @click="toggleObject(props.item)">
                <v-icon>mdi-power</v-icon>
              </v-btn>
              <span>{{props.item.status?"Отключить":"Включить"}}</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
  import entities from '@/mixins/entities'
  export default {
    name : "SettingForm",
    
    mixins: [entities],
    
    props : {
      id : {
        type : Number,
        required : true,
      },
    },
    
    created(){
      this.$store.dispatch('analytics/statistics/getUserSetting', this.id).then( lines => {
        this.objects = lines
        this.convertUuidsToNames(this.objects)
      })
    },
    
    data(){
      return {
        dataObject : {},
        headers: [
          { text: 'Объект', align: 'left', sortable: false },
          { text: 'Действия', align: 'center', sortable: false, width: 40 },
        ],
        objects: [],
        hasChanges: false,
      }
    },
    
    methods : {
      toggleObject(item){
        item.status = !item.status
        let data = { object_id: item.id, status: item.status }
        this.$store.dispatch('analytics/statistics/updateUserSetting', {id: this.id, data}).then( response => this.hasChanges = true)
      },
      
      closeForm(){
        this.$emit('save', {type: 'settings', data:{id: this.id,changes:this.hasChanges}})
      }
    }
    
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Statistics/Forms/SettingForm.vue